import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { authSignUp as actionAuthSignUp } from '../../../redux/auth/actions';

import { Link } from 'react-router-dom';

import CONSTANTS from '../../../constants/index';

import componentStyles from './NewAccountFooter.scss';
import { SELECT, INFO, USER_PHOTO, USER_PROPERTY_CONFLICT } from '../config';
import Clickable from '../../../components/Clickable';

class NewAccountFooter extends Component {
  static propTypes = {
    userData: PropTypes.object,
    authSignUp: PropTypes.func.isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func.isRequired,
    }).isRequired,
    navigateNext: PropTypes.func,
  };

  static defaultProps = {
    userData: null,
    navigateNext: null,
  };

  postData = e => {
    e.preventDefault();

    const { authSignUp, userData, history, navigateNext } = this.props;

    const payload = {
      ...userData,
    };

    delete payload.property;
    delete payload.userData;
    delete payload.errorCode;
    delete payload.block_property;
    delete payload.check_conflicts;

    authSignUp(payload)
      .then(data => {
        if (navigateNext) {
          if (data.property_conflict) {
            navigateNext({ error: true });
          } else {
            navigateNext({ success: true });
          }
        } else {
          history.replace(USER_PHOTO);
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  render() {
    const { userData } = this.props;

    return (
      <>
        <p className={componentStyles.footerText}>Don't have an account?</p>
        <span>
          {userData && userData.errorCode === USER_PROPERTY_CONFLICT ? (
            <Clickable onClick={this.postData}>
              <p className={componentStyles.footerTextButton}>Sign up</p>
            </Clickable>
          ) : (
            <Link
              className={componentStyles.footerTextButton}
              to={
                userData
                  ? {
                      pathname: INFO,
                      state: userData,
                    }
                  : SELECT
              }
            >
              Sign up
            </Link>
          )}
          or
          <a
            className={componentStyles.footerTextButton}
            href={`mailto:${CONSTANTS.QM_SUPPORT_EMAIL}`}
          >
            Contact us
          </a>
        </span>
      </>
    );
  }
}

const bindActions = {
  authSignUp: actionAuthSignUp,
};

export default connect(
  null,
  bindActions,
)(NewAccountFooter);
